import { useEffect, useState } from 'react'
import * as signalR from '@microsoft/signalr'
import SignalRApi from '../../lib/signalr/signralr.services'

export const useConnectSignalR = (isAuthenticated: boolean) => {
	const [connection, setConnection] = useState<signalR.HubConnection | null>(
		null,
	)
	const [isConnected, setIsConnected] = useState(false)
	const [connectionEpoch, setConnectionEpoch] = useState(0)

	useEffect(() => {
		setConnection(null)
		setIsConnected(false)
		if (!isAuthenticated) return

		let isMounted = true

		const connect = async () => {
			try {
				const newConnection = await SignalRApi.createConnection()
				if (!isMounted) return
				newConnection.onreconnecting(() => {
					if (isMounted) setIsConnected(false)
				})
				newConnection.onreconnected(() => {
					if (isMounted) {
						setIsConnected(true)
						setConnectionEpoch(value => value + 1)
					}
				})
				newConnection.onclose(() => {
					if (isMounted) setIsConnected(false)
				})
				setConnection(newConnection)
				setIsConnected(newConnection.state === signalR.HubConnectionState.Connected)
			} catch (error) {
				console.error('Failed to connect SignalR', error)
			}
		}

		connect()

		return () => {
			isMounted = false
			SignalRApi.disconnect()
		}
	}, [isAuthenticated])

	return {
		connection,
		connectionEpoch,
		isConnected: isAuthenticated && isConnected,
	}
}
